export const handleBarSampleDataVertexDomain = {
  CustomerContactName: 'Jane',
  CertificateID: '97909',
  Jurisdiction: 'Florida',
  Reason: 'State Government',
  CertificateStartDate: '2020-01-19',
  RejectionReasons: [
    { RejectionReason: 'Incorrect Jurisdiction' },
    { RejectionReason: 'Incorrect Exemption Reason' },
    { RejectionReason: 'Incorrect Product(s)' },
  ],
  AdditionalInformation: 'The Products are not valid for the Jurisdiction.  The Exemption Reason are not valid for the Products.',
  CorrespondenceEmailAddress: 'If you have any questions or concerns, please reach out to our customer support team.',
  UserFirstLastName: 'Joe Doe',
  ClientCompanyName: 'Vertex Inc',
  SenderEmailAddress: 'ecm@vertexinc.com',
  UnsubscribeLink: 'https://www.vertexinc.com',
  EcwRejectionUrl: 'https://www.vertexinc.com/?cert=276e7003-b79e-4781-b0a3-55a3d89dfbd4&token=bc6f5cfa4c55457ca0de9dd83561baa0',
};

export const handleBarSampleDataCustomDomain = {
  CustomerContactName: 'Jane',
  CertificateID: '97909',
  Jurisdiction: 'Florida',
  Reason: 'State Government',
  CertificateStartDate: '2020-01-19',
  RejectionReasons: [
    { RejectionReason: 'Incorrect Jurisdiction' },
    { RejectionReason: 'Incorrect Exemption Reason' },
    { RejectionReason: 'Incorrect Product(s)' },
  ],
  AdditionalInformation: 'The Products are not valid for the Jurisdiction.  The Exemption Reason are not valid for the Products.',
  CorrespondenceEmailAddress: 'If you have any questions or concerns, please reach out to our customer support team at customer-service@vertexinc.com.', // eslint-disable-line max-len
  UserFirstLastName: 'Joe Doe',
  ClientCompanyName: 'Vertex Inc',
  SenderEmailAddress: 'ecm@vertexinc.com',
  UnsubscribeLink: 'https://www.vertexinc.com',
  EcwRejectionUrl: 'https://www.vertexinc.com/?cert=276e7003-b79e-4781-b0a3-55a3d89dfbd4&token=bc6f5cfa4c55457ca0de9dd83561baa0',
};
